/** Period of a time budget. Only ALLTIME exists for now. */
export enum TimeBudgetPeriod {
    AllTime = 'ALLTIME',
}

/** Error codes of the time budget routes (backend ApiError TBG-*). */
export enum TimeBudgetErrorCode {
    NotFound = 'TBG-001',
    TileAlreadyHasBudget = 'TBG-002',
    InvalidAmount = 'TBG-003',
    TileArchived = 'TBG-004',
    AbsenceTile = 'TBG-005',
    Disabled = 'TBG-006',
    NotVisibleToAllUsers = 'TBG-007',
}

/** Tracked time of one tile path from layer 1 down to the budget's tile; paths without tracked time have no row. */
export interface TimeBudgetUsage {
    layer1TileId: number;
    layer2TileId: number | null;
    layer3TileId: number | null;
    usedSeconds: number;
}

export interface TimeBudget {
    id: number;
    tileId: number;
    budgetSeconds: number;
    // false = switched off (paused); its amount and usage are kept
    active: boolean;
    period: TimeBudgetPeriod;
    usage: TimeBudgetUsage[];
}

export interface TimeBudgetCreateRequestDto {
    tileId: number;
    budgetSeconds: number;
}

// omitted fields keep their value
export interface TimeBudgetUpdateRequestDto {
    budgetSeconds?: number;
    active?: boolean;
}
